"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("../../store/name/actions");
var NameListener = (function () {
    function NameListener() {
    }
    NameListener.listen = function (store) {
        var nameElement = document.getElementById('coinNameInput');
        nameElement.addEventListener('keyup', function () {
            store.dispatch(actions_1.setName({
                name: nameElement.value ? nameElement.value.toUpperCase() : nameElement.value
            }));
        });
    };
    return NameListener;
}());
exports.default = NameListener;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/listeners/betting/name.ts
// module id = 2399
// module chunks = 5